import React from "react";
import SectionShell from "./SectionShell";

export default function SpaceSection() {
  return (
    <SectionShell
      id="ter"
      testId="space-section"
      eyebrow="A közös tér"
      titleStart="Milyen"
      titleAccent="térbe"
      titleEnd=" érkezel?"
      tinted
    >
      {/* Symbolic image — the threshold space where the conversation opens */}
      <figure className="my-8 md:my-10">
        <div className="portrait-frame relative max-w-xl mx-auto">
          <img
            data-testid="space-image"
            src="https://customer-assets.emergentagent.com/job_tiszta-tukor/artifacts/a22yybfr_ChatGPT%20Image%202026.%20j%C3%BAn.%2024.%2022_45_39.png"
            alt="Egy nyitott, meleg fényű pergola — nyugalom, hegyek, naplemente"
            className="w-full h-auto object-cover block"
            style={{
              aspectRatio: "1 / 1",
              filter: "saturate(0.96) contrast(1.02)",
            }}
            loading="lazy"
          />
        </div>
      </figure>

      <p>
        Nem egy olyan helyre, ahol megmondják, mit kell tenned. Hanem egy olyan térbe, ahol
        lehetőséged nyílik más szemszögből ránézni önmagadra, a kapcsolataidra és az életedre.
        A legtöbbször nem azért keresünk segítséget, mert nincs válaszunk. Sokkal inkább
        azért, mert ugyanazokból a nézőpontokból próbáljuk megérteni az életünket, amelyek
        létrehozták a jelenlegi helyzetünket. A közös munka során egy olyan tér nyílik meg,
        ahol lehetőségünk van ránézni azokra a történetekre, amelyeket eddig magától értetődő
        igazságként kezeltél. Azokra a meggyőződésekre, működési mechanizmusokra és mintákra,
        amelyek gyakran észrevétlenül alakítják a döntéseidet, a kapcsolataidat és az
        életedet.
      </p>

      {/* Centered highlight — no rules, clean */}
      <div className="my-6 md:my-8 text-center">
        <p className="font-serif-display italic text-[22px] sm:text-[24px] md:text-[27px] leading-[1.45] text-graphite max-w-xl mx-auto">
          Sokszor nem is az a legnagyobb felismerés, amit meglátunk. Hanem az, amikor
          ráébredünk:
        </p>
        <p className="font-serif-display italic text-[22px] sm:text-[24px] md:text-[27px] leading-[1.45] text-gold max-w-xl mx-auto mt-4">
          „Ja… én ezt eddig tényként kezeltem."
        </p>
      </div>

      <p>
        Attól a pillanattól kezdve valami megváltozik. Mert ami láthatóvá válik, az már
        alakíthatóvá is válik. A tér kitágul. Megjelennek új lehetőségek. Új választások. Új
        nézőpontok. Nem azért, mert megváltoztatjuk a múltat, vagy a másik embert. Hanem mert
        egyre kevésbé szorulunk bele azokba a történetekbe, amelyeket addig valóságnak
        hittünk. Talán ez a valódi szabadság kezdete. Amikor ráébredünk, hogy az élet sokkal
        több lehetőséget tartogat számunkra annál, mint amennyit addig láttunk belőle.
      </p>
    </SectionShell>
  );
}
